module.exports = "/React/dist/22c87ac14edd26298797d91ca935baed.png";